module.exports = __webpack_public_path__ + "static/media/calendar.18a0ab4d.svg";